import { render, staticRenderFns } from "./new-item.vue?vue&type=template&id=84589378&scoped=true"
import script from "./new-item.vue?vue&type=script&lang=js"
export * from "./new-item.vue?vue&type=script&lang=js"
import style0 from "./new-item.vue?vue&type=style&index=0&id=84589378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84589378",
  null
  
)

export default component.exports